import * as React from 'react';

import { Address } from '@typings/graphql';

const IdentifyMemberResultAddress: React.FC<Partial<Address>> = ({
  lineOne,
  lineTwo,
  lineThree,
  city,
  postalCode,
  country,
  state,
  internationalProvince,
}) => (
  <address className="text-xs leading-6">
    {(lineOne || lineTwo || lineThree) && (
      <span data-cy="address-lines">
        {lineOne !== 'No Address Available' && lineOne}
        {lineTwo !== 'No Address Available' && lineTwo && (
          <>
            <br />
            {lineTwo}
          </>
        )}
        {lineThree !== 'No Address Available' && lineThree && (
          <>
            <br />
            {lineThree}
          </>
        )}
        <br />
      </span>
    )}
    <span data-cy="city">
      {city !== 'No Address Available' && city && `${city}, `}
      {state !== 'No Address Available' && state && `${state},`}{' '}
      {postalCode && `${postalCode}, `}
    </span>
    {country !== 'No Address Available' && country}
    {(city || state || postalCode || country) && <br />}
    {internationalProvince}
  </address>
);

export default IdentifyMemberResultAddress;
